module.exports = __webpack_public_path__ + "img/star.e92d38ff.svg";